<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      2.1 {{ $t('common_words.company_location_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ `${$t('common_words.address')}: *` }}</label>
          <br />
          <fg-input
            class="shadow-sm"
            type="textarea"
            :rows="2"
            :placeholder="`${$t('common_words.random_address')}...`"
            v-model="model.address"
            v-validate="modelValidations.address"
            name="common_words.address"
            :error="getError('common_words.address', true)"
          ></fg-input>
          <br />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.country') }}: *</label>
          <br />
          <el-select
            clearable
            @clear="model.city = null"
            id="sPais"
            filterable
            class="select-primary custom-width-select required-second-step shadow-sm"
            v-model="model.country"
            size="large"
            :placeholder="`${$t('common_words.select')}...`"
            @change="updateStates(), updateCities()"
          >
            <el-option
              v-for="option in countries"
              class="select-primary"
              :value="option"
              :label="option"
              :key="option"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.state') }}: *</label>
          <br />
          <el-select
            clearable
            id="sDepartamento"
            filterable
            class="select-primary custom-width-select required-second-step shadow-sm"
            v-model="model.state"
            size="large"
            :placeholder="`${$t('common_words.select')}...`"
            @change="updateCities"
          >
            <el-option
              v-for="option in states"
              class="select-primary"
              :value="option"
              :label="option"
              :key="option"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.city') }}: *</label>
          <br />
          <el-select
            clearable
            id="sCiudad"
            filterable
            class="select-primary custom-width-select required-second-step shadow-sm"
            v-model="model.city"
            size="large"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in cities"
              class="select-primary"
              :value="option"
              :label="option"
              :key="option"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import optionsAddress from 'src/util/optionsAddress';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';

export default {
  data() {
    return {
      model: {
        address: null,
        country: null,
        city: null,
        state: null,
      },
      states: null,
      cities: null,
      countries: null,
      modelValidations: {
        address: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', this.model);
          return res;
        })
        .then((resp) => {
          return store.dispatch(
            'utils/validationInputsRequired',
            '-second-step'
          );
        });
    },

    updateStates() {
      this.model.state = null;
      if (this.model.country) {
        this.states = optionsAddress.setStates(this.model.country);
      } else {
        this.states = [];
      }
    },

    updateCities() {
      this.model.city = null;
      if (this.model.country) {
        this.cities = optionsAddress.setCities(
          this.model.country,
          this.model.state
        );
      } else {
        this.cities = [];
      }
    },

    updateCountries() {
      this.model.country = null;
      this.countries = optionsAddress.setCountries(this.model.country);
    },
  },

  created() {
    this.showHideLoading();
    if (!sessionStorage.getItem('editForm')) {
      this.model.country = 'Colombia';
      this.updateStates();
    }
    this.countries = optionsAddress.setCountries();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.address = editForm.address;
      this.model.country = editForm.country;
      this.updateStates();
      this.model.state = editForm.state;
      this.updateCities();
      this.model.city = editForm.city;
    }
  },
};
</script>
<style></style>
